import React, { useEffect, useState } from "react";

const pad = (n) => String(n).padStart(2, "0");

/** Live countdown to midnight — the 24-hour sale resets every day. */
export const CountdownTimer = () => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const end = new Date();
  end.setHours(24, 0, 0, 0);
  const diff = Math.max(0, end.getTime() - now);
  const h = Math.floor(diff / 3.6e6);
  const m = Math.floor((diff % 3.6e6) / 6e4);
  const s = Math.floor((diff % 6e4) / 1000);

  const units = [
    { v: pad(h), label: "Hrs" },
    { v: pad(m), label: "Min" },
    { v: pad(s), label: "Sec" },
  ];

  return (
    <div
      data-testid="sale-countdown"
      className="inline-flex items-center gap-2 sm:gap-3 border border-gold/70 px-3.5 py-2.5 sm:px-5 sm:py-3.5 [text-shadow:0_1px_10px_rgba(0,0,0,0.65)]"
    >
      <span className="text-[9px] sm:text-[10px] tracking-[0.22em] uppercase text-gold font-semibold pr-1 sm:pr-2 border-r border-gold/30">
        Sale ends in
      </span>
      {units.map((u, i) => (
        <React.Fragment key={u.label}>
          {i > 0 && <span className="text-gold font-heading text-base sm:text-xl -mt-0.5">:</span>}
          <span className="flex flex-col items-center min-w-[2ch]">
            <span className="font-heading text-ivory text-lg sm:text-2xl leading-none tabular-nums" data-testid={`countdown-${u.label.toLowerCase()}`}>
              {u.v}
            </span>
            <span className="text-[8px] sm:text-[9px] tracking-[0.2em] uppercase text-ivory/60 mt-1">{u.label}</span>
          </span>
        </React.Fragment>
      ))}
    </div>
  );
};
